import { toPng } from "html-to-image";

export const questionsEditModeMenuTabs = [
    "EDIT",
    "LOGIC"
    // "SETTINGS",
    // "OTHER"
];

export const defaultSurvey = {
    "type": "test",
    "id": null,
    "questions": [
        {
            "editMode": true,
            "selectedTab": questionsEditModeMenuTabs[0],
            "id": "Q1",
            "options": {},
            "question": undefined,
            "isInvalidQuestion" : undefined
        }
    ],
    "quotaGroups": [],
    "ageQuotas": [],
    "sexQuotas": [],
    "locationQuotas": [],
    "title": "New Survey",
    "points": 0,
    "tickets": 0,
    "start_date": null,
    "end_date": null,
    "filters": {
        "user_max_points": 900000
    }
};

export const defaultQuestion = {
    "editMode": true,
    "selectedTab": questionsEditModeMenuTabs[0],
    "id": undefined,
    "options": {
        "noDKNA": "true"
    },
    "question": undefined
};
export const defaultChoices = [
    {
        "label": "",
        "value": "1"
    },
    {
        "label": "",
        "value": "2"
    }
];

export const defaultSelectsOptions = [
    {
        "label": "",
        "value": 1,
        "disabled": false
    },
    {
        "label": "",
        "value": 2,
        "disabled": false
    },
];

export const defaultQuestionByTypeMap = {
    "singleChoice": {
        "type": "singleChoice",
        "choices": JSON.parse(JSON.stringify(defaultChoices))
    },
    "multipleChoice": {
        "type": "multipleChoice",
        "choices": JSON.parse(JSON.stringify(defaultChoices))
    },
    "text": {
        "type": "text"
    },
    "selects": {
        "type": "selects",
        "selects": [
            {
                "id": undefined,
                "label": "",
                "options": JSON.parse(JSON.stringify(defaultSelectsOptions))
            },
            {
                "id": undefined,
                "label": "",
                "options": JSON.parse(JSON.stringify(defaultSelectsOptions))
            }
        ]
    },
    "jumbotron": {
        "type": "jumbotron"
    },
    "multipleOpen": {
        "type": "multipleOpen",
        "selects": [
            {
                "id": undefined,
                "label": ""
            },
            {
                "id": undefined,
                "label": ""
            },
        ]
    },
    "number": {
        "type": "number"
    },
    "rating": {
        "type": "rating"
    }
};

export const addUISettingsToSurveyQuestions = (survey) => {
    if (typeof survey.questions !== "undefined" && survey.questions.length > 0) {
        for (let i = 0; i < survey.questions.length; i++) {
            survey.questions[i].editMode = false;
            survey.questions[i].selectedTab = questionsEditModeMenuTabs[0];
        }
    }
};

export const MAX_INPUT_NUMBER_VALUE = 999999999;
export const MIN_INPUT_NUMBER_VALUE = 0;

export const iconMapByQType = {
    "singleChoice": "single",
    "multipleChoice": "multi",
    "text": "text",
    "selects": "matrix",
    "jumbotron": "slider",
    "multipleOpen": "multiOpen",
    "number": "number",
    "rating": "rating"
};

export const createNewQuestionForNewType = (oldQuestionData, newQuestionType) => {
    let mergedQuestion = JSON.parse(JSON.stringify(defaultQuestion));

    mergedQuestion.question = oldQuestionData.question;
    mergedQuestion.id = oldQuestionData.id;
    mergedQuestion.question_id = oldQuestionData.question_id;
    mergedQuestion.type = newQuestionType;
    let specificQKeys = Object.keys(defaultQuestionByTypeMap[newQuestionType]);
    for (let i in specificQKeys) {
        let key = specificQKeys[i];
        mergedQuestion[key] = JSON.parse(JSON.stringify(defaultQuestionByTypeMap[newQuestionType][key]));
    }

    mergeQuestionChoices(mergedQuestion, oldQuestionData);

    if(newQuestionType.localeCompare("selects") === 0 || newQuestionType.localeCompare("multipleOpen") === 0) {
        // Add QIDs to selects list after merge
        mergedQuestion.selects.forEach((select, index) => {
            select.id = mergedQuestion.id + "_" + (index + 1);
        });
    }
    return mergedQuestion;
};

export const mergeQuestionChoices = (newQuestion, oldQuestion) => {
    const choicesQTypesList = ["singleChoice", "multipleChoice"];
    const selectsQTypesList = ["selects", "multipleOpen"];
    const questionsWithChoicesList = [...choicesQTypesList, ...selectsQTypesList];

    if(!questionsWithChoicesList.includes(newQuestion.type) || !questionsWithChoicesList.includes(oldQuestion.type)) {
        return;
    }

    const isNewQuestionChoices = choicesQTypesList.includes(newQuestion.type);
    const isOldQuestionChoices = choicesQTypesList.includes(oldQuestion.type);
    const isNewQuestionSelects = selectsQTypesList.includes(newQuestion.type);
    const isOldQuestionSelects = selectsQTypesList.includes(oldQuestion.type);

    if(isOldQuestionChoices) {
        if(isNewQuestionChoices) {
            newQuestion.choices = oldQuestion.choices;
        } else if(isNewQuestionSelects) {
        //    TRANSFORM CHOICES INTO SELECTS
            let selects = [];
            for (let i = 0; i < oldQuestion.choices.length; i++) {
                let choice = oldQuestion.choices[i];
                let select = {
                    "id": undefined,
                    "label": choice.label
                };
                // Options are only needed for type matrix and not multipleOpen
                if(newQuestion.type === "selects") {
                    select.options = JSON.parse(JSON.stringify(defaultSelectsOptions));
                }
                selects.push(select);
            }
            newQuestion.selects = selects;
        }
    } else if(isOldQuestionSelects) {
        if(isNewQuestionChoices) {
        //    TRANSFORM SELECTS INTO CHOICES
            let choices = [];
            for(let i = 0; i < oldQuestion.selects.length; i++) {
                let choice = {
                    "label": oldQuestion.selects[i].label,
                    "value": (i + 1).toString()
                };
                choices.push(choice);
            }
            newQuestion.choices = choices;
        } else if(isNewQuestionSelects) {
        //    TRANSFORM selects depending on questions types (multipleOpen into selects or selects into multipleOpen)
            if(oldQuestion.type === "selects" && newQuestion.type === "multipleOpen") {
                if(typeof oldQuestion.selects !== "undefined" && oldQuestion.selects.length > 0) {
                    let selectsCopy = JSON.parse(JSON.stringify(oldQuestion.selects));
                    for(let i = 0; i < selectsCopy.length; i++) {
                        delete selectsCopy[i].options;
                    }
                    newQuestion.selects = selectsCopy;
                }
            } else if(oldQuestion.type === "multipleOpen" && newQuestion.type === "selects") {
                if(typeof oldQuestion.selects !== "undefined" && oldQuestion.selects.length > 0) {
                    let selectsCopy = JSON.parse(JSON.stringify(oldQuestion.selects));
                    for(let i = 0; i < selectsCopy.length; i++) {
                        selectsCopy[i].options = JSON.parse(JSON.stringify(defaultSelectsOptions));
                    }
                    newQuestion.selects = selectsCopy;
                }
            }
        }
    }
};

export const findNextAvailableQid = (questions) => {
    let count = 1, found = false;
    do {
        found = true;
        for (let j in questions) {
            if (questions[j].id.toUpperCase() === ("Q" + count)) {
                found = false;
                count++;
            }
        }
    } while (!found);
    return "Q" + count;
};

export const findNextAvailableQidForSelect = (selects, questionQId) => {
    let count = 1, found = false;
    do {
        found = true;
        for (let j in selects) {
            if (selects[j].id.toUpperCase() === (questionQId + "_" + count)) {
                found = false;
                count++;
            }
        }
    } while (!found);
    return questionQId + "_" + count;
};

export const decideBooleanString = (oldBooleanString) => {
    if(typeof oldBooleanString !== "undefined") {
        if(oldBooleanString.localeCompare("false") === 0 || oldBooleanString.localeCompare("") === 0) {
            return "true";
        }
        if(oldBooleanString.localeCompare("true") === 0) {
            return "false";
        }
    } else {
        return "true";
    }
};

export const reorderChoicesArray = (choices, sourceIdx, destinationIdx) => {
    //required to update the data into the redux store
    const removed = choices.splice(sourceIdx,1);
    choices.splice(destinationIdx, 0, removed[0]);
};

export const reorderChoicesValues = (choices) => {
    //required to persist the data source
    /* Reordering choice values - to be discussed more in order to prevent user answers issues after the survey is launched */
    for (let choiceIndex = 0; choiceIndex < choices.length; choiceIndex++) {
        choices[choiceIndex].value = (choiceIndex + 1).toString();
    }
};

export const getSurveyStatus = (survey) => {
    const {active, type} = survey;
    if(type.toLowerCase() === "test" && !active) return "DRAFT";
    if(type.toLowerCase() === "short") {
        if(active) {
            return "ACTIVE";
        } else {
            return "CLOSED";
        }
    }

    return "UNKNOWN";
};

export const isSurveyEditRestricted = (survey) => {
    const surveyStatus = getSurveyStatus(survey);
    return !(surveyStatus.toUpperCase() === "DRAFT");
};

const createExportChartPromise = (chartInfo) => {
    return new Promise((resolve) => {
        let chart = chartInfo.chart;
        if (typeof chart.exporting === "undefined") {
            toPng(chart).then(chartBase64 => {
                chartInfo.chartBase64 = chartBase64;
                delete chartInfo.chart;
                resolve(chartBase64);
            });
        }
        else {
            let options = chart.exporting.getFormatOptions("png");
            options.width = 827.88;
            options.height = 313.20;
            chart.exporting.setFormatOptions("png", options);
            chart.exporting.getImage("png").then(chartBase64 => {
                chartInfo.chartBase64 = chartBase64;
                delete chartInfo.chart;
                resolve(chartBase64);
            });
        }
    });
};

export const createChartsPayloadPromise = async (surveyId, surveyTitle, generalStats, questionChartsInfo) => {
    let questionChartsInfoCopy = questionChartsInfo.map((chartInfo) => { return {...chartInfo}; });
    let chartsPromises = questionChartsInfoCopy.map((chartInfoCopy) => { return createExportChartPromise(chartInfoCopy); });
    let chartsPromisesResults = await Promise.all(chartsPromises);

    let exportPptChartsPayload = {surveyId, surveyTitle, generalStats, chartsDetails: questionChartsInfoCopy};
    exportPptChartsPayload.textsAsSlideTitles = true;
    return exportPptChartsPayload;
};

export const generateMenuFromTemplatesList = (templates) => {
    let templatesMenu = [];

    if (templates) {
        templates.forEach(template => {
            const category = template.category;
            const categoryIndex = templatesMenu.findIndex(cat => cat.categoryName === category.categoryName);

            if (categoryIndex !== -1) {
                templatesMenu[categoryIndex].templatesList.push(template)
            } else {
                category.templatesList = [template];
                templatesMenu.push(category);
            }
        });

        templatesMenu.sort((c1, c2) => {
            return c1.categoryOrder - c2.categoryOrder;
        });
    }

    return templatesMenu;
};